import React from 'react';
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form';
import { FormControlLabel, Switch } from '@mui/material';

export function SwitchField<FormValue extends FieldValues>({
  name,
  label,
}: {
  name: Path<FormValue>;
  label: string;
}) {
  // TODO how to enforce typing checking of FormValue[name] is boolean ?
  const { control } = useFormContext<FormValue>();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, value, ...field }, fieldState: { error } }) => (
        <FormControlLabel
          control={<Switch {...field} checked={value as boolean} />}
          label={label}
        />
      )}
    />
  );
}
